import React from 'react'

import { connect } from 'react-redux'
import { setTrackCached } from '../../actions'

import { slugify } from '../../utils'

import * as Cloud from '../visuals/Cloud'

const mapStateToProps = (state, ownProps) => ({

})

const mapDispatchToProps = (dispatch) => ({

})

class DownloadBookButton extends React.Component {

  download = async () => {
    console.log('Download book!')
  }

  render () {
    return <Cloud.Download onClick={this.download} />
  }
}


DownloadBookButton = connect(mapStateToProps, mapDispatchToProps)(DownloadBookButton)

export default DownloadBookButton



// WEBPACK FOOTER //
// ./src/components/Main/DownloadBookButton.js